module.exports = __webpack_public_path__ + "static/media/kisko-horizontal.3b6edf97.svg";